import BuyersFilterContent from "./Buyers";
import DocumentTypeFilterContent from "./DocumentType";
import KeywordsFilterContent from "./Keywords";
import PublishedDateFilterContent from "./PublishedDate";

// Add new filters to this map
export const documentFilterContents = {
  keywords: KeywordsFilterContent,
  documentType: DocumentTypeFilterContent,
  buyers: BuyersFilterContent,
  publishedDate: PublishedDateFilterContent,
};
